/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Collection(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33374 16.667H14.9998V18.333H3.33374C2.87541 18.333 2.48239 18.1701 2.15601 17.8438C1.82983 17.5175 1.66683 17.1251 1.66675 16.667V5H3.33374V16.667ZM16.6667 1.66699C17.125 1.66699 17.5172 1.83 17.8435 2.15625C18.1698 2.48256 18.3337 2.87481 18.3337 3.33301V13.333C18.3337 13.7913 18.1699 14.1844 17.8435 14.5107C17.5172 14.8369 17.1249 15 16.6667 15H6.66675C6.20858 15 5.8163 14.8369 5.48999 14.5107C5.1636 14.1844 4.99976 13.7913 4.99976 13.333V3.33301C4.99983 2.87481 5.16368 2.48256 5.48999 2.15625C5.81633 1.82996 6.20851 1.66701 6.66675 1.66699H16.6667ZM6.66675 13.333H16.6667V3.33301H6.66675V13.333ZM15.8337 11.667H7.49976L9.74976 8.75L11.0417 10.417L12.9587 7.91699L15.8337 11.667Z"
        fill="#35424F"
      />
    </svg>
  )
}

Collection.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Collection
